import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormCafeteriaInsumoComponent from '../components/FormCafeteriaInsumoComponent';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';

var config = process.env;

class AddCafeteriaInsumoPage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, disabled: false };
    }

    async componentDidMount() {
        const role = await validateSession();
        this.setState({ checked: true, role });
    }

    handleChangeData = (value) => {
        this.setState({ disabled: true });
        const request = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
            body: JSON.stringify(value),
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'cafeteria/supplies', request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    this.setState({ disabled: false });
                    if (data.error === 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                } else {
                    navigateTo('/cafeteriaInsumos');
                }
            });
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={29} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <HeaderComponent title="Cafetería" subtitle="Nuevo insumo" />
                            <FormCafeteriaInsumoComponent
                                onChangeData={this.handleChangeData}
                                disabled={this.state.disabled}
                                role={this.state.role}
                            />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default AddCafeteriaInsumoPage;
